import { shouldLogBackend } from "./logging-policy";
import { EnvironmentType } from "@models/env";
import { environment } from "src/environments/environment";

/**
 * Flags de funcionalidades por ambiente.
 *
 * PIX_PAYMENT_ENABLED
 * -------------------
 * Habilita todos os fluxos de PIX em homologação para testes.
 * Em produção, o PIX continua desativado.
 */
export const PIX_PAYMENT_ENABLED = environment.env === EnvironmentType.homolog;

/**
 * PAYMENT_GRPC_DEADLINE_ENABLED
 * -----------------------------
 * Quando ligado, envia o header `grpc-timeout` nas chamadas que finalizam
 * pagamento — ou seja, o front passa a impor um prazo à chamada.
 *
 * DESLIGADO por decisão de produto: o controle de timeout dos fluxos de
 * pagamento é 100% do backend / middleware. O gateway (Rede) leva mais de 2 min
 * em homologação, e com o deadline ligado era o front que derrubava a chamada
 * antes da hora — deixando a cobrança em estado indefinido. Se demorar 10 min,
 * quem decide cortar é o back.
 *
 * Efeito prático de estar `false`: nenhum `grpc-timeout` e nenhum timeout de
 * XHR partem do cliente (o grpc-web só define os dois quando existe a metadata
 * `deadline`). Em contrapartida, o proxy gRPC volta a aplicar o timeout de rota
 * dele — se a borda cortar cedo demais, o ajuste é lá (`max_grpc_timeout` /
 * route timeout no Envoy), não aqui.
 */
export const PAYMENT_GRPC_DEADLINE_ENABLED = false;

/** Backend diagnostics: dev/homolog and localhost, never deployed production. */
export const SERVER_DEBUG_LOG_ENABLED = shouldLogBackend(
  environment.env,
  typeof window === 'undefined' ? '' : window.location.hostname,
);